"use client";
import { useEffect } from "react";
import { useAnalytics } from "@/components/providers/analytics-provider";

export function AdvertiseAnalyticsTracker() {
  const { trackTyped } = useAnalytics();
  useEffect(() => {
    trackTyped("advertise_page_view", {});
  }, [trackTyped]);
  return null;
}
